<template>
  <section class="jielv-module-nav" aria-label="捷旅生产运营导航">
    <div class="module-hero">
      <div class="module-copy">
        <div class="module-eyebrow">捷旅生产运营中心</div>
        <h1>{{ title }}</h1>
        <p>{{ description }}</p>
      </div>
      <div class="module-runtime">
        <slot name="status">
          <el-tag :type="statusTagType" effect="dark" size="small"><i :class="statusIcon" /> {{ statusText }}</el-tag>
        </slot>
        <span v-if="updatedAt" class="module-updated">最近刷新：{{ updatedAt }}</span>
        <span v-if="autoRefreshText" class="module-updated">{{ autoRefreshText }}</span>
        <el-button v-if="refreshable" size="small" :loading="loading" icon="el-icon-refresh" @click="$emit('refresh')">刷新当前页</el-button>
      </div>
    </div>
    <nav class="module-links" aria-label="捷旅模块功能">
      <button
        v-for="item in links"
        :key="item.path"
        type="button"
        class="module-link"
        :class="{ 'is-active': isCurrent(item.path) }"
        @click="navigate(item.path)"
      >
        <i :class="item.icon" />
        <span>{{ item.label }}</span>
      </button>
    </nav>
  </section>
</template>

<script>
export default {
  name: 'JielvModuleNav',
  props: {
    title: { type: String, required: true },
    description: { type: String, default: '' },
    status: { type: String, default: 'healthy' },
    statusText: { type: String, default: '运行正常' },
    updatedAt: { type: String, default: '' },
    autoRefreshText: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    refreshable: { type: Boolean, default: true },
  },
  data() {
    return {
      links: [
        { label: '运营总览', path: '/jielv/overview', icon: 'el-icon-monitor' },
        { label: '发布控制', path: '/jielv/hotel-publish-controls', icon: 'el-icon-office-building' },
        { label: '活动价核对', path: '/jielv/activity-rates', icon: 'el-icon-price-tag' },
        { label: '并发与积压', path: '/jielv/worker-controls', icon: 'el-icon-cpu' },
        { label: '推送时效', path: '/jielv/push-monitor', icon: 'el-icon-data-line' },
        { label: '酒店映射', path: '/jielv/hotel-mappings', icon: 'el-icon-map-location' },
        { label: '订单监控', path: '/jielv/order-monitor', icon: 'el-icon-connection' },
      ],
    }
  },
  computed: {
    statusTagType() {
      return ({ healthy: 'success', success: 'success', loading: 'info', info: 'info', warning: 'warning', danger: 'danger' })[this.status] || 'info'
    },
    statusIcon() {
      return ({ healthy: 'el-icon-success', success: 'el-icon-success', loading: 'el-icon-loading', info: 'el-icon-info', warning: 'el-icon-warning', danger: 'el-icon-warning' })[this.status] || 'el-icon-info'
    },
  },
  methods: {
    isCurrent(path) {
      return Boolean(this.$route && this.$route.path === path)
    },
    navigate(path) {
      if (this.isCurrent(path) || !this.$router) return
      this.$router.push(path)
    },
  },
}
</script>

<style scoped>
.jielv-module-nav { margin: -4px 0 18px; overflow: hidden; border: 1px solid #cfe6e2; border-radius: 8px; background: #fff; box-shadow: 0 4px 16px rgba(23, 73, 78, .08); }
.module-hero { display: flex; align-items: center; justify-content: space-between; gap: 24px; padding: 20px 22px; color: #fff; background: linear-gradient(120deg, #164e63 0%, #147d7e 58%, #25a18e 100%); }
.module-copy { min-width: 0; }
.module-eyebrow { margin-bottom: 6px; color: #c9f2ed; font-size: 12px; letter-spacing: 2px; }
.module-hero h1 { margin: 0; font-size: 24px; line-height: 32px; }
.module-hero p { max-width: 860px; margin: 6px 0 0; color: #d9f5f1; font-size: 13px; line-height: 20px; }
.module-runtime { display: flex; align-items: center; justify-content: flex-end; gap: 10px; flex-wrap: wrap; min-width: 240px; }
.module-updated { color: #d9f5f1; font-size: 12px; white-space: nowrap; }
.module-runtime ::v-deep .el-button { color: #126a6c; border-color: rgba(255, 255, 255, .8); background: #fff; }
.module-links { display: grid; grid-template-columns: repeat(7, minmax(112px, 1fr)); padding: 0 10px; background: #fff; }
.module-link { position: relative; display: flex; align-items: center; justify-content: center; gap: 7px; min-height: 48px; padding: 0 10px; border: 0; outline: 0; color: #606266; font: inherit; font-size: 13px; cursor: pointer; background: transparent; transition: color .2s, background .2s; }
.module-link:hover { color: #168477; background: #f0faf8; }
.module-link.is-active { color: #11766c; font-weight: 600; background: #eaf8f5; }
.module-link.is-active::after { position: absolute; right: 18px; bottom: 0; left: 18px; height: 3px; content: ''; border-radius: 3px 3px 0 0; background: #20a38f; }
@media (max-width: 1200px) {
  .module-hero { align-items: flex-start; flex-direction: column; }
  .module-runtime { justify-content: flex-start; min-width: 0; }
  .module-links { grid-template-columns: repeat(4, 1fr); }
}
@media (max-width: 600px) {
  .module-hero { padding: 16px; }
  .module-hero h1 { font-size: 20px; }
  .module-links { grid-template-columns: repeat(2, 1fr); padding: 0; }
  .module-link { min-height: 44px; }
}
</style>
